import React from 'react';
import { getTheme, INavLink, INavProps, INavStyles, ITheme, Nav } from '@fluentui/react';
import { useNavigator } from '../../services/navigation';

const getNavStyles = (theme: ITheme) => {
  const navStyles: Partial<INavStyles> = {
    root: {
      width: 220,
      height: '100%',
      boxSizing: 'border-box',
      border: 'none',
      backgroundColor: theme.palette.white,
      overflowY: 'auto',
    },
    // these link styles override the default truncation behavior
    link: {
      lineHeight: 'inherit',
    },
  };
  return navStyles;
}

export const BwjNav: React.FunctionComponent<INavProps> = (props) => {
  const theme = getTheme();
  const navStyles = getNavStyles(theme);
  const originalOnLinkClick = props.onLinkClick;
  const p = {...props};
  if(!p.styles) {
    p.styles = navStyles;
  }
  const navigator = useNavigator();

  p.onLinkClick = (ev?: React.MouseEvent<HTMLElement, MouseEvent>, item?: INavLink) => {
    if(!!originalOnLinkClick) {
      originalOnLinkClick(ev, item);
      if(ev?.isPropagationStopped() ?? false) { return; }
    }

    if(!!item) {
      ev?.preventDefault();
      ev?.stopPropagation();
      navigator.goTo(item.url);
    }
  };
  
  return (
    <Nav {...p} />
  );
};
